import React, { useState } from "react";
import { MillDashboardContext } from "./MillDashboardsContext";
import { IMillDashboardsContextProps } from "./MillDashboardsContextInterfaces";
import { initialState } from "./MillDashboardsContext";

export const MillDashboardContextProvider: React.FC<IMillDashboardsContextProps> = ({ children }) => {
    const [showDetails, setShowDetails] = useState<boolean>(initialState.showDetails);
    const [displayUnit, setDisplayUnit] = useState<string | number>(initialState.displayUnit);
    const [showOnlyPending, setShowOnlyPending] = useState<boolean>(true);
    const [topHeaderArea, setTopHeaderArea] = useState(initialState.topHeaderArea);
    const [reportRangeEndDate, setReportRangeEndDate] = useState(initialState.reportRangeEndDate);
    const [reportRangeStartDate, setReportRangeStartDate] = useState(initialState.reportRangeStartDate);

    const showOrHideDetails = (value: boolean) => {
        setShowDetails(value);
    };

    const handleChangeDisplayUnit = (value: string | number) => {
        setDisplayUnit(value);
    };

    const showOrHideOnlyPending = (value: boolean) => {
        setShowOnlyPending(value);
    };

    const handleSetTopHeaderArea = (value: React.ReactNode) => {
        setTopHeaderArea(value);
    };

    const handleSetReportRangeEndDate = (value: Date) => {
        setReportRangeEndDate(value);
    };

    const handleSetReportRangeStartDate = (value: Date) => {
        setReportRangeStartDate(value);
    };

    const providerValue = {
        showDetails,
        showOnlyPending,
        showOrHideOnlyPending,
        showOrHideDetails,
        displayUnit,
        handleChangeDisplayUnit,
        topHeaderArea,
        handleSetTopHeaderArea,
        reportRangeEndDate,
        handleSetReportRangeEndDate,
        reportRangeStartDate,
        handleSetReportRangeStartDate,
    };

    return <MillDashboardContext.Provider value={providerValue}>{children}</MillDashboardContext.Provider>;
};
